import React from 'react';
import { useMediaQuery } from '@mui/material';

import DesktopApp from './App';
import AppMobile from './mobile/AppMobile';

type UxOverride = 'desktop' | 'mobile';

function getUxOverrideFromUrl(): UxOverride | null {
  try {
    const url = new URL(window.location.href);
    const raw = (url.searchParams.get('ux') || '').toLowerCase().trim();
    if (raw === 'desktop') return 'desktop';
    if (raw === 'mobile') return 'mobile';
    return null;
  } catch {
    return null;
  }
}

/**
 * AppRoot
 * - Keeps the existing desktop app fully intact.
 * - Adds a separate mobile UI module and selects which to render.
 * - Safety override: `?ux=desktop` or `?ux=mobile`.
 *
 * Tablet UX is intentionally NOT enabled yet (iPad testing pending).
 */
export default function AppRoot() {
  const uxOverride = getUxOverrideFromUrl();

  // Default mobile breakpoint (matches existing usage in App.tsx).
  const isMobile = useMediaQuery('(max-width:600px)');

  // TODO(tablet): Enable tablet UX after testing on iPad 11" (keep OFF for now).
  // const ENABLE_TABLET_UX = false;
  // const isTablet = useMediaQuery('(min-width:601px) and (max-width:1024px)');

  if (uxOverride === 'desktop') {
    return <DesktopApp />;
  }
  if (uxOverride === 'mobile') {
    return <AppMobile />;
  }

  if (isMobile) {
    return <AppMobile />;
  }

  return <DesktopApp />;
}

